import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function CheckboxUnchecked(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="19" height="19" stroke="currentColor" />
      </svg>
    </SvgIcon>
  );
}
